// src/components/event/SyncedLyrics.jsx
import React, { useEffect, useMemo, useRef } from 'react'

/**
 * lines 예시:
 * [
 *   { time: 0, text: '첫 줄 가사' },
 *   { time: 5.2, text: '두 번째 줄 가사' },
 *   ...
 * ]
 * time 단위는 "초" 기준이라고 가정
 */
const SyncedLyrics = ({
                          audioRef,
                          lines = [],
                          currentTime = 0,
                          onSeek,
                      }) => {
    const lineRefs = useRef([])

    /** 현재 시간에 해당하는 가사 index 계산 */
    const activeIndex = useMemo(() => {
        if (!Array.isArray(lines) || lines.length === 0) return -1

        for (let i = 0; i < lines.length; i += 1) {
            const cur = lines[i]
            const next = lines[i + 1]

            if (!next) {
                if (currentTime >= cur.time) return i
            } else if (currentTime >= cur.time && currentTime < next.time) {
                return i
            }
        }
        return -1
    }, [lines, currentTime])

    /** activeIndex 바뀔 때마다 해당 줄로 자동 스크롤 */
    useEffect(() => {
        if (activeIndex < 0) return
        const el = lineRefs.current[activeIndex]
        if (!el || typeof el.scrollIntoView !== 'function') return

        el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        })
    }, [activeIndex])

    return (
        <div className="space-y-1">
            {lines.map((line, idx) => {
                const isActive = idx === activeIndex
                return (
                    <button
                        key={`${line.time}-${idx}`}
                        type="button"
                        ref={(el) => {
                            lineRefs.current[idx] = el
                        }}
                        onClick={() => onSeek?.(line.time)}
                        className={`block w-full rounded-md px-1 py-0.5 text-left text-[0.8rem] leading-relaxed transition ${
                            isActive
                                ? 'bg-white/15 text-yellow-400'
                                : 'text-slate-100/80 hover:bg-white/5 hover:text-slate-50'
                        }`}
                    >
                        {line.text}
                    </button>
                )
            })}
        </div>
    )
}

export default SyncedLyrics
